import React, { useEffect, createContext, useState } from 'react';
import Cookies from 'js-cookie';
import useFeatureFlagEntries from 'hooks/useFeatureFlagEntries';

const FeatureFlagContext = createContext();

export default FeatureFlagContext;

export const FeatureFlagProvider = ({ children }) => {
  const featureFlagEntries = useFeatureFlagEntries();

  const [flags, setFlags] = useState({});

  useEffect(() => {
    const newFlags = { ...flags };

    featureFlagEntries.forEach((feature) => {
      const flag = feature?.optimizelySelector;
      if (flag && Cookies.get(flag) === 'true') {
        newFlags[flag] = feature;
      }
    });

    setFlags(newFlags);
  }, [featureFlagEntries]);

  return <FeatureFlagContext.Provider value={flags}>{children}</FeatureFlagContext.Provider>;
};
